export default function (name) {
  if(name == undefined){return '';}
  return name.split("\\").pop().split('/').pop();
}